import React from 'react'
import * as voteStyles from '../../styles/project-modules/bills/votes.module.less'
import { convertDatesToAP } from '../sfc/component-helpers/datehelpers'
import Person from './Person'
import Table from '../elements/Table'
import DotPlot from './dotPlot'
import { capfirst } from 'journalize'

const VOTE_TYPES = [
  { label: 'yes', key: 'yea', type: 1, class: voteStyles.yes },
  { label: 'no', key: 'nay', type: 2, class: voteStyles.no },
  { label: 'no vote', key: 'nv', type: 3, class: voteStyles.noVote },
  { label: 'absent', key: 'absent', type: 4, class: voteStyles.absent },
]

function Votes({ yourLegislators, chamber, data }) {
  const split_date = data.roll_call_date.split('-')
  //javascript zero indexes date, so we subtract one from the month
  const date = new Date(split_date[0], split_date[1] - 1, split_date[2])
  const dateString = convertDatesToAP(
    date.toLocaleString('en-US', {
      month: 'long',
      day: 'numeric',
      year: 'numeric',
    })
  )

  const yourLegislatorsOCD_IDS = yourLegislators
    ? yourLegislators.map((l) => l.ocd_id)
    : null

  let tableData = data.vote_details.map((v) => ({
    Lawmaker: (
      <Person
        name={v.name}
        // img={v.photoUrl}
        party={v.party_id}
        district={v.district}
        className={
          yourLegislatorsOCD_IDS && yourLegislatorsOCD_IDS.includes(v.ocd_id)
            ? voteStyles.highlight
            : ''
        }
      />
    ),
    Vote: (
      <span
        className={`${voteStyles.result} ${
          VOTE_TYPES.find((i) => i.type === v.vote_id).class
        }`}
      >
        {capfirst(VOTE_TYPES.find((i) => i.type === v.vote_id).label)}
      </span>
    ),
  }))

  return (
    <div className={voteStyles.container}>
      <div className={voteStyles.contentContainer}>
        <div className={voteStyles.exp}>
          <h4 className={voteStyles.date}>
            {dateString}: {data.roll_call_desc}
          </h4>
          <p id={`chart-label-${chamber}`}>
            {VOTE_TYPES.map((type) => (
              <>
                <span className={type.class}>{capfirst(type.label)}</span>:{' '}
                {data[type.key]} lawmaker{data[type.key] === 1 ? '' : 's'}
                <br />
              </>
            ))}
            {/* The bill {data.passed === 0 ? 'did not pass' : 'passed'} with{' '}
            <span>{data.yea === 0 ? 'no' : apnumber(data.yea)}</span> lawmaker
            {data.yea === 1 ? '' : 's'} voting{' '}
            <span className={voteStyles.yes}>Yes</span> and{' '}
            {data.nay === 0 ? 'zero' : apnumber(data.nay)} lawmaker
            {data.nv === 1 ? '' : 's'} voting{' '}
            <span className={voteStyles.no}>No.</span>
            {data.nv > 0 && (
              <>
                {' '}
                {capfirst(apnumber(data.nv))} lawmaker{data.nv === 1 ? '' : 's'}{' '}
                <span className={voteStyles.noVote}>did not vote.</span>
              </>
            )}{' '}
            {data.absent > 0 && (
              <>
                {capfirst(apnumber(data.absent))} lawmaker
                {data.nv === 1 ? '' : 's'} {data.absent === 1 ? 'was' : 'were'}{' '}
                <span className={voteStyles.absent}>absent</span>.
              </>
            )}{' '} */}
          </p>
          <div className={voteStyles.barChartContainer}>
            <DotPlot
              data={data}
              dataLabels={VOTE_TYPES}
              labeledById={`#chart-label-${chamber}`}
              groupBy={'party_id'}
            />
          </div>
        </div>
        <div className={voteStyles.tableContainer}>
          <Table data={tableData} useKeys={['Lawmaker', 'Vote']} />
        </div>
      </div>
    </div>
  )
}

export default Votes
